import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { TopbarInfoWrapper } from '@/pages/_base/TopbarInfoWrapper';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
  type: string;
  currentTab: string;
}

export function TabAdminWrapper({ children, type, currentTab }: Props) {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  const { t } = useTranslation(ENUM__i18n_namespace.SETTINGS_USER);

  if (currentTab != type) return <></>;

  return (
    <>
      <div
        className={`h-full bg-component  text-page-foreground flex flex-col text-left`}
        style={{ width: `${global_is_mobile ? '100%' : `calc(100vw - ${CONSTANTS__client.SIDEBAR_LEFT_WIDTH + 50}px)`}` }}
      >
        <TopbarInfoWrapper>
          <span className={`text-left px-4 ${md('bg-component border-b border-component-border pb-1', '')}`}>{type}</span>
        </TopbarInfoWrapper>
        <div className={`pb-2  ${md('overflow-auto px-2 bg-component', 'px-8')}`}>{children}</div>
      </div>
    </>
  );
}
